<template>
  <app-main />
</template>

<script>
import { AppMain } from './components'

export default {
  name: 'Layout',
  components: {
    AppMain
  },
  computed: {},
  methods: {}
}
</script>
